import { css as o } from "@emotion/react";
import { RADIUS as u, FONTS as a } from "../../../constants.mjs";
import { noDefaultFocusMixin as f } from "../../../mixins.mjs";
const l = o`
    text-decoration: none;

    box-sizing: border-box;

    ${f}

    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    word-break: break-word;
    hyphens: auto;

    min-height: 2.75rem;
    min-width: 4.75rem;

    padding: 0.25rem 1rem;

    border: 0px;
    border-radius: ${u.SMALL};

    cursor: pointer;

    font-size: 1rem;
    line-height: 1.125rem;
    font-family: ${a.PRIMARY};
    font-weight: 600;

    color: var(--button-text-color);
    background: var(--button-background-color);
    :hover {
        background: var(--button-background-hover-color);
    }
    :active {
        background: var(--button-background-active-color);
    }

    &[aria-disabled='true'] {
        cursor: not-allowed;
        color: var(--button-disabled-text-color);
        background: var(--button-disabled-background-color);
    }

    > * {
        flex-shrink: 0;
    }
`, d = o`
    width: 100%;
`, i = o`
    :focus {
        outline: 2px solid var(--button-focus-color);
        outline-offset: 2px;
    }
`, g = o`
    color: transparent;
    cursor: wait;
`, x = o`
    position: absolute;
    color: var(--button-text-color);
`, r = {
  dark: {
    accent: o`
            --button-text-color: #ffffff;
            --button-background-color: #3959ff;
            --button-background-hover-color: #3552e7;
            --button-background-active-color: #314acf;
        `,
    primary: o`
            --button-text-color: #0f0f0f;
            --button-background-color: #ffffff;
            --button-background-hover-color: #e7e7e7;
            --button-background-active-color: #cfcfcf;
        `,
    secondary: o`
            --button-text-color: #ffffff;
            --button-background-color: rgba(255, 255, 255, 0.07);
            --button-background-hover-color: rgba(255, 255, 255, 0.12);
            --button-background-active-color: rgba(255, 255, 255, 0.21);
        `,
    destructive: o`
            --button-text-color: #0f0f0f;
            --button-background-color: #ff5c5c;
            --button-background-hover-color: #e75555;
            --button-background-active-color: #cf4d4d;
        `,
    base: o`
            --button-focus-color: #ffffff;
            --button-disabled-text-color: rgba(255, 255, 255, 0.21);
            --button-disabled-background-color: rgba(255, 255, 255, 0.07);
        `
  },
  light: {
    accent: o`
            --button-text-color: #ffffff;
            --button-background-color: #274afe;
            --button-background-hover-color: #2342e5;
            --button-background-active-color: #1f3bcb;
        `,
    primary: o`
            --button-text-color: #ffffff;
            --button-background-color: #0f0f0f;
            --button-background-hover-color: #272727;
            --button-background-active-color: #333333;
        `,
    secondary: o`
            --button-text-color: #0f0f0f;
            --button-background-color: rgba(15, 15, 15, 0.05);
            --button-background-hover-color: rgba(15, 15, 15, 0.09);
            --button-background-active-color: rgba(15, 15, 15, 0.15);
        `,
    destructive: o`
            --button-text-color: #ffffff;
            --button-background-color: #dd1d1d;
            --button-background-hover-color: #c71a1a;
            --button-background-active-color: #b11717;
        `,
    base: o`
            --button-focus-color: #0f0f0f;
            --button-disabled-text-color: rgba(15, 15, 15, 0.2);
            --button-disabled-background-color: rgba(15, 15, 15, 0.05);
        `
  }
}, h = ({ theme: t, variant: c, hideFocus: n, loading: b, fullWidth: e }) => [
  l,
  r[t][c],
  r[t].base,
  !n && i,
  b && g,
  e && d
];
export {
  x as buttonSpinnerStyles,
  h as getButtonStyles
};
